import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../../../utils/api";

function UploadAudioDocs() {
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [scanning, setScanning] = useState(false);
  const [content, setContent] = useState("");
  const [error, setError] = useState("");
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loadingBatches, setLoadingBatches] = useState(false);
  const [minutes, setMinutes] = useState(1);
  const navigate = useNavigate();

  // Fetch batches when component mounts
  useEffect(() => {
    const fetchCategory = async () => {
      try {
        setLoadingBatches(true);
        const response = await apiService.getAudioExercises();
        if (response.data) {
          setCategory(response.data);
        } else {
          console.error("Failed to fetch batches:");
        }
      } catch (err) {
        console.error("Error fetching batches:", err);
      } finally {
        setLoadingBatches(false);
      }
    };

    fetchCategory();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      if (!title) {
        setTitle(selectedFile.name.split(".")[0]);
      }

      // Create a preview for the image
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        // setImgSrc(reader.result);
      });
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      setError("Please select a file to uload");
      return;
    }

    if (!minutes) {
      setError("PLese slect minute");
      return;
    }

    if(!content){
      setError("PLese write content");
      return;
    }

    // Check if batch is selected - only required for teachers
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.role === "teacher" && !selectedCategory) {
      setError("Please select a batch for this document");
      return;
    }

    setScanning(true);
    setError("");

    try {
      const fileToUpload = file;
      console.log("Using image:", fileToUpload);

      const formData = new FormData();
      formData.append("document", fileToUpload);
      formData.append("title", title);
      formData.append("minutes", minutes);
      formData.append("content", content);

      // Add batch ID to form data if selected
      if (selectedCategory) {
        formData.append("categoryId", selectedCategory);
      }

      // Log the form data to verify what's being sent
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      const response = await apiService.scanAudioDocument(formData);
      const data = response.data;

      if (data.success) {
        navigate(`/dashboard/teacher/documents-audio/${data.document.id}`);
      } else {
        setError(data.message || "Failed to upload document");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error uploading document");
      console.error(err);
    } finally {
      setScanning(false);
    }
  };

  // Check if current user is a teacher
  const isTeacher = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user && user.role === "teacher";
  };

  return (
    <div className="scanner-container">
      <h2>Upload Document</h2>

      <form onSubmit={handleSubmit} className="upload-form">
        <div className="form-group">
          <label>Document Title:</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Enter document title" required />
        </div>

        <div className="form-group">
          <label>Select Exercise Level:</label>
          <select value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} required disabled={loadingBatches}>
            <option value="">Select a Exercise Level</option>
            {category.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.level}
              </option>
            ))}
          </select>
          {loadingBatches && <span className="loading-text">Loading Exercise Level...</span>}
        </div>

        <div className="form-group">
          <label>Minutes:</label>
          <input type="number" value={minutes} onChange={(e) => setMinutes(Math.max(1, parseInt(e.target.value) || 1))} min="1" required />
        </div>

        <div className="file-input-container">
          <input type="file" onChange={handleFileChange} accept="audio/*" id="file-upload" className="file-input" />
          <label htmlFor="file-upload" className="file-label">
            {file ? file.name : "Choose a file"}
          </label>
        </div>

        <div className="form-group">
          <label>Document Content:</label>
          <textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder="Enter document description" />
        </div>

        {error && <p className="error-message">{error}</p>}

        <div className="button-group">
          <button type="button" onClick={() => navigate("/dashboard/teacher")} className="cancel-button">
            Cancel
          </button>
          <button type="submit" className="scan-button" disabled={!file || scanning || (isTeacher() && !selectedCategory)}>
            {scanning ? "Uploading..." : "Upload Document"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default UploadAudioDocs;
